import React from 'react';
import { Link } from 'react-router-dom';
import Wrapper from 'components/layouts/Wrapper/Wrapper';
import { Headers } from 'components/core';

interface ReportCard {
  title: string;
  subtitle: string;
  to: string;
}

const REPORTS: ReportCard[] = [
  {
    title: 'Check Aging Report',
    subtitle: "Outstanding cashier's checks aged from first mail date.",
    to: '/reports/check-aging',
  },
  {
    title: 'Refund Report',
    subtitle: 'Payments returned to you after they were sent to the vendor.',
    to: '/reports/refunds',
  },
  {
    title: 'Cancellation Report',
    subtitle: 'Payments canceled before they were sent to the vendor.',
    to: '/reports/cancellations',
  },
  {
    title: 'Pending Payables Report',
    subtitle:
      'Payables awaiting a vendor to onboard on PayUp before they can be approved for payment.',
    to: '/reports/pending-payables',
  },
];

export const ReportsLanding: React.FC = () => {
  return (
    <Wrapper additionalClasses="flex-col items-start" pageTitle="Reports">
      <Headers headingContent="Reports" />
      <div className="grid w-full grid-cols-1 gap-4 py-4 md:grid-cols-2 lg:grid-cols-3">
        {REPORTS.map((r) => (
          <Link
            key={r.to}
            to={r.to}
            className="group flex flex-col rounded-lg bg-white p-6 shadow-analyticsCard transition hover:shadow-dropDown"
          >
            <span className="text-18s font-bold text-gray-900 group-hover:text-primary-500">
              {r.title}
            </span>
            <span className="mt-2 text-14s text-gray-600">{r.subtitle}</span>
          </Link>
        ))}
      </div>
    </Wrapper>
  );
};

export default ReportsLanding;
